import { render, staticRenderFns } from "./egrulRecordsItem.vue?vue&type=template&id=205fb15a&scoped=true&"
import script from "./egrulRecordsItem.vue?vue&type=script&lang=js&"
export * from "./egrulRecordsItem.vue?vue&type=script&lang=js&"
import style0 from "./egrulRecordsItem.vue?vue&type=style&index=0&id=205fb15a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205fb15a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('205fb15a')) {
      api.createRecord('205fb15a', component.options)
    } else {
      api.reload('205fb15a', component.options)
    }
    module.hot.accept("./egrulRecordsItem.vue?vue&type=template&id=205fb15a&scoped=true&", function () {
      api.rerender('205fb15a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/egrulRecords/egrulRecordsItem.vue"
export default component.exports